module.exports = __webpack_public_path__ + "img/ИФ-1(А)-019-m.6b8703e7.png";